import React from "react";
import { useNavigate } from "react-router";
import homeBanner from "../assets/homeBannner.png";
import { IoBagCheckOutline } from "react-icons/io5";
import { GoClock } from "react-icons/go";
import { CiCircleCheck } from "react-icons/ci";
import { useStores } from "../stores";

export default function Home() {
  const navigate = useNavigate();
  const { clientsStore } = useStores();

  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return "Good Morning";
    } else if (currentHour < 18) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };
  return (
    <div className="w-full">
      <div className=" relative w-full">
        <img
          src={homeBanner}
          alt="homeBanner"
          className="mt-0 h-[25vh] object-cover object-center w-full"
        />
        <div className="absolute inset-y-0 right-3 flex items-center justify-center pr-4">
          <p className=" text-white text-2xl font-bold">
            {getGreeting()} {clientsStore.user.name},
          </p>
        </div>
      </div>
      <div className="bg-slate-400 p-10">
        <div className="w-full gap-10 flex">
          <div
            className="mt-2 bg-white shadow-lg w-[30%] h-[20%] rounded-lg"
            onClick={() => navigate("/dashboard/all-awakens")}
          >
            <p className="py-6 pb-3 flex flex-row items-center gap-3 font-semibold border-b w-[80%] mx-auto text-left ">
              <span className="bg-yellow-200 flex items-center justify-center w-6 h-6 rounded-xl">
                <IoBagCheckOutline className="text-blue-700 " />
              </span>
              Awaken
            </p>
            <div className="flex items-center justify-between">
              <p className="p-6 items-center font-semibold text-blue-700">
                New awaken's
              </p>
              <p className="text-black text-3xl p-6">16</p>
            </div>
          </div>
          <div className="mt-2 bg-white shadow-lg w-[30%] h-[20%] rounded-lg">
            <p className="py-6 pb-3 flex flex-row items-center gap-3 font-semibold border-b w-[80%] mx-auto text-left ">
              <span className="bg-violet-300 flex items-center justify-center w-6 h-6 rounded-xl">
                <GoClock className="text-violet-700 " />
              </span>
              Pending Leads
            </p>
            <div className="flex items-center justify-between">
              <p className="p-6 items-center font-semibold text-violet-700">
                Pending awaken's
              </p>
              <p className="text-black text-3xl p-6">16</p>
            </div>
          </div>
          <div className="mt-2 bg-white shadow-lg w-[30%] h-[20%] rounded-lg">
            <p className="py-6 pb-3 flex flex-row items-center gap-3 font-semibold border-b w-[80%] mx-auto text-left ">
              <span className="bg-green-200 flex items-center justify-center w-6 h-6 rounded-xl">
                <CiCircleCheck className="text-green-700 " />
              </span>
              Completed Leads
            </p>
            <div className="flex items-center justify-between">
              <p className="p-6 items-center font-semibold text-green-700">
                Completed awaken's
              </p>
              <p className="text-black text-3xl p-6">16</p>
            </div>
          </div>
        </div>
        <p className="font-semibold mt-5 mb-3">Recent activity</p>
        <div className="flex w-full overflow-x-auto">
          <div className="w-[64%] mr-4 bg-white shadow-lg rounded-lg h-[50%] overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="flex items-start justify-start whitespace-nowrap p-4">
                  <th className="text-center px-7 py-2">S.no</th>
                  <th className="text-center px-7 py-2">
                    Name of the Finacial Planner
                  </th>
                  <th className="text-center px-7 py-2">Created On</th>
                  <th className="text-center px-7 py-2">View</th>
                </tr>
              </thead>
              <tbody>
                <tr className="flex items-start justify-start whitespace-nowrap px-4 border-b">
                  <td className="text-center px-7 py-2">01</td>
                  <td className="text-center px-7 py-2">
                    sathish kumar saradi
                  </td>
                  <td className="text-center px-7 py-2">11 jan 24</td>
                  <td className="text-center px-7 py-2">
                    <button
                      className="border-2 px-2 rounded-lg"
                      onClick={() => {
                        // This would typically open a specific report
                        // For now, it's a placeholder that could be updated with actual report data
                        alert("Report functionality will be implemented here");
                      }}
                    >
                      view report{" "}
                    </button>
                  </td>
                </tr>

                <tr className="flex items-start justify-start whitespace-nowrap px-4 border-b">
                  <td className="text-left px-7 py-2">01</td>
                  <td className="text-left px-7 py-2">sathish kumar saradi</td>
                  <td className="text-left px-7 py-2">11 jan 24</td>
                  <td className="text-left px-7 py-2">
                    <button
                      className="border-2 px-2 rounded-lg"
                      onClick={() => {
                        // This would typically open a specific report
                        // For now, it's a placeholder that could be updated with actual report data
                        alert("Report functionality will be implemented here");
                      }}
                    >
                      view report{" "}
                    </button>
                  </td>
                </tr>

                <tr className="flex items-start justify-start whitespace-nowrap px-4 border-b">
                  <td className="text-left px-7 py-2">01</td>
                  <td className="text-left px-7 py-2">sathish kumar saradi</td>
                  <td className="text-left px-7 py-2">11 jan 24</td>
                  <td className="text-left px-7 py-2">
                    <button
                      className="border-2 px-2 rounded-lg"
                      onClick={() => {
                        // This would typically open a specific report
                        // For now, it's a placeholder that could be updated with actual report data
                        alert("Report functionality will be implemented here");
                      }}
                    >
                      view report{" "}
                    </button>
                  </td>
                </tr>

                <tr className="flex items-start justify-start whitespace-nowrap px-4 border-b">
                  <td className="text-left px-7 py-2">01</td>
                  <td className="text-left px-7 py-2">sathish kumar saradi</td>
                  <td className="text-left px-7 py-2">11 jan 24</td>
                  <td className="text-left px-7 py-2">
                    <button
                      className="border-2 px-2 rounded-lg"
                      onClick={() => {
                        // This would typically open a specific report
                        // For now, it's a placeholder that could be updated with actual report data
                        alert("Report functionality will be implemented here");
                      }}
                    >
                      view report{" "}
                    </button>
                  </td>
                </tr>

                <tr className="flex items-start justify-start whitespace-nowrap px-4 border-b">
                  <td className="text-left px-7 py-2">01</td>
                  <td className="text-left px-7 py-2">sathish kumar saradi</td>
                  <td className="text-left px-7 py-2">11 jan 24</td>
                  <td className="text-left px-7 py-2">
                    <button
                      className="border-2 px-2 rounded-lg"
                      onClick={() => {
                        // This would typically open a specific report
                        // For now, it's a placeholder that could be updated with actual report data
                        alert("Report functionality will be implemented here");
                      }}
                    >
                      view report{" "}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="w-[30%] h-[50%] ml-5">
            <div className="w-full h-[76%] bg-white shadow-lg rounded-lg p-2">
              <p className="font-semibold whitespace-nowrap">
                Leads From Last Week
              </p>
            </div>
            <div className="w-full h-[20%] bg-white shadow-lg rounded-lg p-2 mt-4">
              <p className="text-blue-500 font-semibold">Total Leads</p>
              <p className="text-4xl text-center p-5">165</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
